import { combineReducers } from 'redux';
import level1Reducer from './reducers/level1Reducer';
import level2Reducer from './reducers/level2Reducer';
import positionReducer from './reducers/positionReducer';
import instrumentReducer from './reducers/instrumentReducer';
import productReducer from './reducers/productReducer';
import orderHistoryReducer from './reducers/orderHistoryReducer';
var apexCore = combineReducers({
  level1: level1Reducer,
  level2: level2Reducer,
  position: positionReducer,
  instrument: instrumentReducer,
  product: productReducer,
  orderHistory: orderHistoryReducer
});
export default apexCore;